import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const Terms = () => (
  <LegalPageLayout
    title="Terms of Service"
    subtitle="The terms that govern your use of Aurora Wealth Reserves websites and online services."
  >
    <p>
      These Terms of Service (&ldquo;Terms&rdquo;) govern your access to and use of the websites, online banking,
      and related digital services operated by Aurora Wealth Reserves (&ldquo;Aurora,&rdquo; &ldquo;we,&rdquo;
      &ldquo;us,&rdquo; or &ldquo;our&rdquo;). By accessing or using our Services, you agree to these Terms.
      If you do not agree, do not use the Services.
    </p>

    <h2>1. Eligibility &amp; Accounts</h2>
    <p>
      You must be legally able to enter a binding contract and meet any eligibility requirements for the
      products you request. You agree to provide accurate information and to keep your login credentials confidential.
      You are responsible for activity that occurs under your account credentials, except where prohibited by law
      or caused by our failure to use commercially reasonable security measures.
    </p>

    <h2>2. Online Banking &amp; Digital Services</h2>
    <p>
      Online banking features may include account viewing, transfers, bill pay, card management, and support tools.
      Availability may vary by product, jurisdiction, and verification status. We may modify, suspend, or discontinue
      features with notice when required. Scheduled maintenance or outages may temporarily interrupt access.
    </p>

    <h2>3. Acceptable Use</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the Services for unlawful, fraudulent, or abusive purposes</li>
      <li>Attempt to gain unauthorized access to systems, accounts, or data</li>
      <li>Interfere with the security, integrity, or performance of the Services</li>
      <li>Reverse engineer or scrape the Services except where permitted by law</li>
      <li>Misrepresent your identity or affiliation</li>
    </ul>

    <h2>4. Electronic Communications</h2>
    <p>
      By using the Services, you consent to receive disclosures, notices, and communications electronically,
      including by email, in-product messages, or alerts. You may withdraw consent where the law allows, which
      may limit your ability to use certain digital features.
    </p>

    <h2>5. Fees, Rates &amp; Product Terms</h2>
    <p>
      Account fees, interest rates, and product-specific terms are described in the applicable account agreements,
      fee schedules, and disclosures. Those documents control if they conflict with these general Terms.
      See our <Link to="/disclosures">Disclosures</Link> page for additional important information.
    </p>

    <h2>6. Intellectual Property</h2>
    <p>
      The Aurora Wealth Reserves name, logos, content, and software are owned by us or our licensors.
      You receive a limited, non-exclusive, non-transferable license to use the Services for personal or
      authorized business banking purposes. You may not copy, modify, or distribute our materials without permission.
    </p>

    <h2>7. Disclaimers</h2>
    <p>
      Except as expressly stated in a written account agreement or required by law, the Services are provided
      &ldquo;as is&rdquo; and &ldquo;as available.&rdquo; We do not warrant uninterrupted or error-free operation.
      Market information, calculators, and educational content are for general information only and are not
      investment, tax, or legal advice.
    </p>

    <h2>8. Limitation of Liability</h2>
    <p>
      To the fullest extent permitted by law, Aurora Wealth Reserves and its affiliates will not be liable for
      indirect, incidental, special, consequential, or punitive damages, or for lost profits, data, or goodwill,
      arising from your use of the Services. Our aggregate liability for claims relating to the digital Services
      is limited as set out in your account agreements and applicable law.
    </p>

    <h2>9. Indemnity</h2>
    <p>
      You agree to indemnify and hold harmless Aurora Wealth Reserves from claims arising out of your misuse
      of the Services, violation of these Terms, or infringement of another party&rsquo;s rights, except to the
      extent caused by our gross negligence or willful misconduct.
    </p>

    <h2>10. Termination</h2>
    <p>
      We may suspend or terminate access to digital Services if you violate these Terms, pose a security risk,
      or as required by law. You may stop using the Services at any time. Provisions that by nature should survive
      (including intellectual property, disclaimers, and liability limits) will survive termination.
    </p>

    <h2>11. Governing Law</h2>
    <p>
      These Terms are governed by the laws applicable to Aurora Wealth Reserves and your account agreements,
      without regard to conflict-of-law principles that would require another jurisdiction&rsquo;s law.
      Venue and dispute procedures follow those agreements and applicable consumer banking rules.
    </p>

    <h2>12. Changes</h2>
    <p>
      We may update these Terms periodically. Material changes will be posted on this page with an updated date.
      Continued use after the effective date constitutes acceptance where permitted by law.
    </p>

    <h2>13. Contact</h2>
    <p>
      Questions about these Terms: <a href="mailto:support@aurorawealthreserves.com">support@aurorawealthreserves.com</a>,
      or visit our <Link to="/contact">Contact</Link> page.
    </p>
  </LegalPageLayout>
);

export default Terms;
